export default __webpack_public_path__ + "static/media/favicon.af3e3754.ico";